module.exports = __webpack_public_path__ + "static/img/SmartPitch.e17be9ea.svg";